import { defineAction } from '~/prix'
import immunobiologicalCollectAction from './immunobiologicalCollect.action.json' with { type: 'json' }
import { z } from 'zod'

const immunobiologicalCollectDefinition = defineAction({
  ...immunobiologicalCollectAction,

  input: z.object({}),
  output: z.object({}),
})

export default immunobiologicalCollectDefinition
